import axios from 'axios'

export default axios.create({
    baseURL: 'https://campaignapi.lpn.co.th/api'
    // baseURL: 'http://localhost:4102/api'
})
